import React, { Component } from 'react';
import $ from "jquery";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

export default class ViewSurveyResults extends Component {
  constructor() {
    super();
    this.state = {
      surveyResultData: [],
      pageNum: null,
      isLoading: true,
      noMatchingData : false,
    }
    this.userDetails = JSON.parse(localStorage.getItem("user_details"));
  }

  componentDidMount() {
    var thisController = this;
    localStorage.setItem("SurveyResultsTab", "Hide")

    setTimeout(() => {
      thisController.fetchPatientName();
      // thisController.fetchManageAdmissionDetails();
    }, 300);
  }

  fetchPatientName() {
    var thisController = this;

    $.ajax({
      url: "/my-jeeva-api/fetch-survey-results-patient",
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        surveyId: localStorage.getItem("surveyId")
      },
      success: function (res) {
        if (res.success == true) {
          var patientSurveyData = res.result;
          thisController.state.surveyResultData = res.result;
          thisController.state.isLoading = false;
          thisController.state.noMatchingData = false;
          thisController.setState(thisController.state);
        } else {
          thisController.state.noMatchingData = false;
          thisController.state.isLoading = false;
          thisController.setState(thisController.state);
        }
      },
    });
  }

  showSurveyResults = (row, e) => {
    localStorage.setItem("surveyIdOfTreatment", row.surveyId);
    localStorage.setItem("patientAddmissionId", row.answeredBy);
    localStorage.setItem("surveyTitle", row.title);
    localStorage.setItem("patientName", row.answeredByName)
    this.props.history.push("/projectmgmt/survey/view-patient-survey-results");
  };

  onPageChange = (e) => {
    this.setState({ pageNum: e })
  }

  openDeletePopUp = (id) => {

    confirmAlert({
      title: 'Confirm to Delete',
      message: 'Are you sure to delete this? ',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.deleteSurveyResult(id)
        },
        {
          label: 'No',
        }
      ]
    });
  }
  deleteSurveyResult = (id) => {
    let surveyResultData = this.state.surveyResultData;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;

    if (id == "") {
      surveyResultData.splice(id, 1);
    } else {
      $.ajax({
        url: "/my-jeeva-api/delete-survey-result/" + id,

        method: 'DELETE',
        headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
        success: function (res) {
          if (res.success === true) {
            surveyResultData.splice(id, 1);
            // deleteConstructorVariables.notifyDelete();
            deleteApiViewController.refreshData();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        }
      });
    }


  }
  refreshData = (id) => {
    console.log("Resetting the data");
    this.state.surveyResultData = [];
    this.setState(this.state);
    this.fetchPatientName();
  }
  goBackSurveyHomePage = () => {
    localStorage.setItem("SurveyResultsTab", "Show");

    this.props.history.push({
      pathname: '/projectmgmt/survey',
    });
  }

  caseInsensitiveSort = (field) => (rowA, rowB) => {
    const a = rowA[field].toLowerCase();
    const b = rowB[field].toLowerCase();

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };

  handleSearch = (event) => {
    var thisController = this;
    var searchTerm = event.target.value;
    thisController.state.searchTerm = searchTerm;
    thisController.state.isLoading = true;
    thisController.state.surveyResultData = [];
    thisController.setState(thisController.state);

    $.ajax({
      url: "/my-jeeva-api/search-survey-attends",
      method: "GET",
      data: {
        surveyId: localStorage.getItem("surveyId"),
        searchTerm: searchTerm
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        if (res.success === true) {
          if (res.result.length > 0) {
            thisController.state.surveyResultData = [];
            thisController.setState(thisController.state);
            thisController.state.surveyResultData = res.result;
            thisController.state.isLoading = false;
            thisController.state.noMatchingData = false;
            thisController.setState(thisController.state);
          } else {
            thisController.state.noMatchingData = true;
            thisController.setState(thisController.state);
          }
        }
      },
      error: function (xhr) {

      },
    });

  };

  getColumns() {
    const columns = [
      {
        name: <b style={{ fontSize: "16px" }}>Patient Name</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('answeredByName'),
        selector: (row) => (
          <div
            className="textarea"
            style={{
              background: "white",
              height: "2.7em",
              resize: "none",
              paddingTop: "6px",
              width: "100%",
              border: "none",
              borderRadius: "2px",
              textAlign: "start",
            }}
          >
            {row.answeredByName}
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Patient Email</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('answeredByEmail'),
        selector: (row) => (
          <div
            className="textarea"
            style={{
              background: "white",
              height: "2.7em",
              resize: "none",
              paddingTop: "6px",
              width: "100%",
              border: "none",
              borderRadius: "2px",
              textAlign: "start",
            }}
          >
            {row.answeredByEmail}
          </div>
        ),
      },
      { 
        name: <b style={{ fontSize: "16px" }}>Response Date</b>,
       
        selector: (row) => (row.answeredOn &&
          <div
            className="textarea"
            style={{
              background: "white",
              height: "2.7em",
              resize: "none",
              paddingTop: "6px",
              width: "100%",
              border: "none",
              borderRadius: "2px",
              textAlign: "start",
            }}
          >
             {new Date(row.answeredOn).toLocaleDateString("en-US")}
          </div>
        ),
      },
      {
        name: (
          <div Align="center">
            <b style={{ fontSize: "16px" }}>Action</b>
          </div>
        ),
        width: "200px",
        selector: (row) => (
          <div
            style={{
              background: "white",
              height: "2.7em",
              resize: "none",
              paddingLeft: "2px",
              paddingTop: "6px",
              display: "flex",
            }}
          >

            <button

              style={{
                backgroundColor: "#282a65",
                border: "none",
                color: "white",
                borderRadius: "8px",
              }}
              onClick={(e) => {
                this.showSurveyResults(row, e);
              }}
            >
              Survey Result
            </button>
          </div >
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
    ];
    return columns;
  }

  render() {
    return (
      <div className="main-survey"
        style={{ marginLeft: "1vh", height: "60vh", marginRight: "3vh" }}>

        <div style={{
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
        }}>

          <img
            className="img-responsive"
            src="./assets/images/arrow.svg"
            onClick={this.goBackSurveyHomePage}
            style={{ cursor: "pointer" }}
          />

          <h6
            className="nav-item"
            style={{
              color: "#282a65",
              marginTop: "10px",
              fontSize: "20px",
            }}
          >
            Results of Survey
          </h6>
          <input
            type="text"
            style={{
              width: "12vw",
              border: "2px solid #777676",
              borderRadius: "10px",
              padding: "10px",
              height: "0.7vw",
              marginLeft: "50vw"
            }}
            value={this.state.searchTerm}
            onChange={this.handleSearch}
            placeholder="Search ..."
          />
        </div>

        <br />
        {!this.state.noMatchingData && <div style={{ boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
          {this.state.isLoading && (
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <p>Loading ...</p>
            </div>
          )}
          {!this.state.isLoading && this.state.surveyResultData.length === 0 && (
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <p>There are no patients attended this survey</p>
            </div>
          )}
          {this.state.surveyResultData.length > 0 && (
            <DataTable
              columns={this.getColumns()}
              data={this.state.surveyResultData}
              defaultPageSize={5}
              pageSizeOptions={[5, 10, 15]}
              onPageChange={this.onPageChange}
              pagination={this.state.paginationValue}
            />)}
        </div>}
        <div className='card'>
                    {this.state.noMatchingData &&
                        <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                            <p>No matching options found ...</p>
                        </div>
                    }
                </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ViewSurveyResults.js